var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sortedActions),function(action){return _c('data-list-action',{key:action.handle,attrs:{"action":action,"selections":1},on:{"selected":_vm.run},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var action = ref.action;
var select = ref.select;
return _c('div',{},[_c('button',{class:{ warning: action.dangerous },domProps:{"textContent":_vm._s(_vm.__(action.title))},on:{"click":select}})])}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }